export const iconNames = {
    preview: "DocumentSearch",
    reject: "Blocked",
    forward: "FollowUser",
    approve: "Accept"
};
